import * as React from 'react';
import { Route, Switch } from 'react-router-dom';

import loadable from '@loadable/component';

import { loadableDelay, params } from '@common/react/loadable/loadableSettings';

import ScrollTopAll from '@app/hooks/ScrollTopAll';
import Layout from '@app/components/Layout';
import LayoutLanding from '@app/components/LayoutLanding';

const Children = loadable(() =>
	loadableDelay(import(/* webpackChunkName: "Contacts" */ '@app/components/Pages/Children/Children')), params);

export const routes = (
	<Layout>
		<Switch>
			<Route>
				<ScrollTopAll>
					<LayoutLanding>
						<Route component={Children} />
					</LayoutLanding>
				</ScrollTopAll>
			</Route>
		</Switch>
	</Layout>
);
